import {
  Button,
  Header,
  SpaceBetween,
  Box,
  CollectionPreferences,
  ColumnLayout,
  Modal,
  FormField,
  Input,
} from "@awsui/components-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Campaign } from "../../appstore/models";

export interface TableHeaderProps {
  title: string;
  deleteDisabled: boolean;
  deleteCallback: any;
}

export const TableHeader = (props: TableHeaderProps) => {
  return (
    <Header
      actions={
        <SpaceBetween size="xs" direction="horizontal">
          <Button
            disabled={props.deleteDisabled}
            onClick={() => props.deleteCallback()}
          >
            Delete jobs
          </Button>
          <Link to="/geo-campaigns/new">
            <Button variant="primary">Create Campaign</Button>
          </Link>
        </SpaceBetween>
      }
    >
      {props.title}
    </Header>
  );
};

export const TableEmptyState = (props: { onClearFilter: any }) => (
  <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
    <SpaceBetween size="xxs">
      <div>
        <b>No Jobs Found</b>
        <Box variant="p" color="inherit">
          There are no jobs in the pipeline that match your search
        </Box>
      </div>
      <Button onClick={props.onClearFilter}>Clear filter</Button>
    </SpaceBetween>
  </Box>
);

export interface PreferenceProps {
  preferences: {
    pageSize: number;
    visibleContent: string[];
    wrapLines?: boolean;
  };
  setPreferences: any;
}

export const Preferences = (props: PreferenceProps) => {
  const { preferences, setPreferences } = props;
  return (
    <CollectionPreferences
      title="Preferences"
      confirmLabel="Confirm"
      cancelLabel="Cancel"
      preferences={preferences}
      onConfirm={({ detail }) => setPreferences(detail)}
      pageSizePreference={{
        title: "Page size",
        options: [
          { value: 10, label: "10 Jobs" },
          { value: 20, label: "20 Jobs" },
        ],
      }}
      wrapLinesPreference={{
        label: "Wrap lines",
        description: "Check to see all the text and wrap the lines",
      }}
      visibleContentPreference={{
        title: "Select visible columns",
        options: [
          {
            label: "Main job properties",
            options: [
              { id: "JobName", label: "Job name", editable: false },
              { id: "JobStatus", label: "Job status" },
              { id: "SubmitTime", label: "Submit time" },
              { id: "EndTime", label: "End time" },
            ],
          },
        ],
      }}
    />
  );
};

export interface DeleteModalProps {
  onCancel: any;
  onConfirm: any;
  selectedJobs: Campaign[];
  isVisible: boolean;
}

export const DeleteModal = (props: DeleteModalProps) => {
  let [allowJobDeletion, setAllowJobDeletion] = useState<boolean>(false);
  let [confirmTyped, setConfirmTyped] = useState<string>("");

  const inputChange = (currentValue: string) => {
    setConfirmTyped(currentValue);
    currentValue.toLowerCase() === "permanently delete"
      ? setAllowJobDeletion(true)
      : setAllowJobDeletion(false);
  };

  useEffect(() => {
    setConfirmTyped("");
  }, [props.isVisible]);
  return (
    <Modal
      visible={props.isVisible}
      onDismiss={() => props.onCancel()}
      header={`Delete ${props.selectedJobs.length} job${
        props.selectedJobs.length > 1 ? "s" : ""
      }?`}
      closeAriaLabel="Close dialog"
      footer={
        <div className="awsui-util-f-r">
          <Button variant="link" onClick={() => props.onCancel()}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={!allowJobDeletion}
            onClick={() => props.onConfirm()}
          >
            Delete Permanently
          </Button>
        </div>
      }
    >
      <ColumnLayout borders="horizontal">
        <div data-awsui-column-layout-root={true}>
          <div>
            <p>
              Delete{" "}
              <strong>
                {props.selectedJobs.length} job
                {props.selectedJobs.length > 1 ? "s" : ""}
              </strong>{" "}
              permanently? This action cannot be undone.
            </p>
          </div>
          <FormField
            label={
              <div>
                To confirm deletion, enter the the text 'permanently delete' in
                the input field.
              </div>
            }
            stretch={true}
            className="awsui-util-mt-xs"
          >
            <Input
              value={confirmTyped}
              placeholder="permanently delete"
              onChange={({ detail }) => inputChange(detail.value)}
              ariaRequired={true}
            />
          </FormField>
        </div>
      </ColumnLayout>
    </Modal>
  );
};
